
import { tokens } from "../../theme/theme";
import {  Typography, Card, CardContent, Grid,  Button, useTheme, Box, } from "@mui/material";

// icons 
import LooksOutlinedIcon from '@mui/icons-material/LooksOutlined';
import { useTranslation } from "react-i18next";

const WarehouseManagementMenu = ({ SetActive, handleBackDashboard }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();

    const callback = () => {
        handleBackDashboard();
    };

    return (
        <Box >
            <Card sx={{ backgroundColor: "transparent", borderRadius: "0px", height: "48px" }}>
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center" >
                        <Typography variant="h5" color={colors.grey[100]} fontWeight="bold" justifyContent="center">Warehouse Management </Typography>
                    </Box>
                </CardContent>
            </Card>   

            {/* <Divider /> */}
            {/* <Box p={2}>
                <Grid container spacing={2} justifyContent="start" marginTop="10px"  >
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <LooksOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>List Of warehouse</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("Warehouse")}>View</Button>
                        </Card>
                    </Grid>
                </Grid>
            </Box> */}            

            <Box p={1}>
                <Grid container spacing={2} justifyContent="flex-start" >
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card
                            elevation={3}
                            sx={{
                                backgroundColor: colors.primary[400],
                                //theme.palette.background.paper,
                                borderRadius: 3,
                                p: 3,
                                textAlign: "center",
                                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                "&:hover": {
                                    transform: "translateY(-5px)",
                                    boxShadow: theme.shadows[6],
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    width: 60,
                                    height: 60,
                                    mx: "auto",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: colors.primary[400],
                                    // theme.palette.secondary.light,
                                    borderRadius: "50%",
                                    mb: 2,
                                }}
                            >
                                <LooksOutlinedIcon fontSize="large" color="secondary" />
                            </Box>
                            <Typography variant="h6" fontWeight={600}>
                                List of Warehouse
                            </Typography>
                            <Button
                                variant="contained"
                                color="secondary"
                                sx={{ mt: 2 }}
                                onClick={() => SetActive("Warehouse")}
                            >
                                View
                            </Button>
                        </Card>
                    </Grid>
                </Grid>
            </Box>

            {/* <Box p={2}>
                <Grid container spacing={2} justifyContent="flex-start" mt={2}>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card
                            sx={{
                                backgroundColor: colors.primary[400],
                                p: 2,
                                borderRadius: 2,
                                textAlign: "left",
                                transition: "0.3s",
                                "&:hover": {
                                     backgroundColor:colors.primary[300],
                                },
                            }}
                        >
                            <Typography variant="subtitle2" color="text.secondary">Menu</Typography>
                            <Typography variant="h6">List of Warehouse</Typography>
                            <Button size="small" onClick={() => SetActive("Warehouse")}>
                                Go →
                            </Button>
                        </Card>
                    </Grid>
                </Grid>
            </Box> */}

        </Box>

    )
}
export default WarehouseManagementMenu;